export enum ContractType {
    ADMIN = 'ADMIN',
    MAINTAINER = 'MAINTAINER',
    USER = 'USER'
}
